export default __webpack_public_path__ + "static/integrations_klaviyo-8776762a846e8d9cbbf94e7d717894d4.png";